import { Anchor, Breadcrumbs } from '@mantine/core';
import queryString from 'query-string';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import FacebookAdsNewForm from '../../components/Facebook/Ads/FacebookAdsNewForm';
import Metadata from '../../components/Metadata';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import { Page } from '../../constants/pageTitles';

const page = `${Page['facebookAds']}`;

const FacebookAdsNewPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [guidanceShow, setGuidanceShow] = useState(false);
  const [facebookAd, setFacebookAd] = useState();

  const { from } = queryString.parse(location.search);
  const { accountId, domainId } = useParams();

  const close = (facebookAd) => {
    setFacebookAd(facebookAd);
    setGuidanceShow(true);
  };

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/facebook/ads` },
    { title: 'New' },
  ].map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="Facebook Ad"
        redirect={`/accounts/${accountId}/domains/${domainId}/facebook/ads`}
        show={guidanceShow}
        elementTypes={['campaigns', 'workflows']}
        element={facebookAd}
        setShow={() => setGuidanceShow(false)}
        newElement={true}
      />
      <FacebookAdsNewForm
        onCreate={(facebookAd) => {
          close(facebookAd);
        }}
        onBack={() => navigate(-1)}
        from={from}
      />
    </>
  );
};

export default FacebookAdsNewPage;
